export default "__VITE_ASSET__DIOn72AH__ 400w, __VITE_ASSET__Dioz0K_b__ 800w, __VITE_ASSET__DN$_QQtR__ 1024w";